<template>
  <div id="app">
  
    <router-view/>
  </div>
</template>
<script>

</script>
<script>
import { getUrlKey } from "@/utils/main";
window.onload = function() {
 document.addEventListener('touchstart', function(event) {
 if (event.touches.length > 1) {
  event.preventDefault()
 }
 })
 document.addEventListener('gesturestart', function(event) {
 event.preventDefault()
 })
 
}
export default {
  name: 'App',
  mounted () {
    let title = getUrlKey("title");
    if(title==1){
      window.document.title='劲络课堂'
    }else if(title==2){
      
      window.document.title='劲络品牌'
    }
      else{
      window.document.title='溯源防伪查询'
    }
    if (this.isWeChatBrowser()) {
    console.log('当前环境是微信浏览器');

} else {
//  this.$router.push('/wx/error');
    console.log('当前环境不是微信浏览器');
}
    // document.body.addEventListener('touchmove', function (e) {
    //     e.preventDefault() // 阻止默认的处理方式(阻止下拉滑动的效果)
    // }, {passive: false}) // passive 参数不能省略，用来兼容ios和android
},
methods: {
  isWeChatBrowser() {
    return /micromessenger/i.test(navigator.userAgent);
    }
}

}
</script>


<style lang="scss" >
//去除默认样式
p,
dl,
dt,
dd,
ul,
li {
  margin: 0;
  padding: 0;
}
ul,
li {
  list-style: none;
}
button {
  border: none; // 清除默认边框
  background-color: none;
  outline: none;
}
input {
  outline: none;
  outline-color: none;
}
input::-webkit-input-placeholder {
  color: #4d6ff0;
}
textarea {
  border: none;
  outline: none;
  resize: none;
}
//vant提示框确定文字颜色
.van-dialog__confirm {
  color: #E7BCA5;
}
//公共样式
.flexc {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
#app {

font-family: Source Han Sans CN;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
}
body {
  letter-spacing: 1px;
  background-color: #fafafa;
// background: #ECF0F3;
  input::-webkit-input-placeholder {
    color: #d7d6d6;
    text-align: left;
    
    padding-right: 10px;
  }
  position: relative;
}
.zIndex {
  z-index: 9999999999999999 !important;
}
/** list 状态css */
.list_img_status {
  position: absolute;
  right: 0px;
  top: 0px;
  height: 100%;
  max-height: 65px;
}
.list_img_status2 {
  position: absolute;
  right: 0px;
  top: 50%;
  height: 50%;
}
/**地区选择css**/
.areaCss {
  width: 100%;
  height: 300px;
  background: #ffffff;
  overflow: auto;
}
/**全屏弹出层 **/
.full_window {
  // top: 0px;
  left: 0px;
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 10;
  overflow: auto;
}
/**加载图标**/
.spinner_loading {
  margin-top: 50px;
  text-align: center;
}
/** 底部css */
.footer {
  background: #ffffff;
  padding-top: 10px;
  padding-bottom: 10px;
  box-sizing: border-box;
  width: 100%;
  text-align: center;
  margin-top: 10px;
  clear: both;
  button {
    width: 95%;
    margin: 0 auto;
    margin-bottom: 10px;
  }
}
.footer_step {
  bottom: 0px;
  position: fixed;
  width: 100%;
  z-index: 10;
  cursor: pointer;
  button {
    width: 50%;
    // border: 0px;
    border: none;
    // height: 100%;
    background: #ffffff;
    padding: 0px;
    font-size: 16px;
    letter-spacing: 1px;
    height: 50px;
    line-height: 50px;
    border-top: 1px solid #1b814b;
    cursor: pointer;
  }
  .last {
    color: #1b814b;
  }
  .next {
    background: #1b814b;
    color: #ffffff;
  }
}
.footer_step2 {
  margin-top: 20px;
  bottom: 0px;
  width: 100%;
  z-index: 10;
  cursor: pointer;
  button {
    width: 30%;
    // border: 0px;
    border: none;
    // height: 100%;
    background: #ffffff;
    padding: 0px;
    font-size: 16px;
    letter-spacing: 1px;
    height: 50px;
    line-height: 50px;
    border-top: 1px solid #1b814b;
    cursor: pointer;
    border: 1px solid #1b814b;
    border-radius: 10px;
  }
  .last {
    color: #1b814b;
    margin-right: 20px;
  }
  .next {
    background: #1b814b;
    color: #ffffff;
  }
}
// 重写全局图片查看层置顶
.pswp {
  z-index: 9999999999999999 !important;
}
input .van-field__control::-webkit-input-placeholder {
  color: #4d6ff0;
}
input::input-placeholder{
  color: #4d6ff0;
}
.van-nav-bar__content{
 
// background: linear-gradient(60deg, #547aff, #547aff);
}
 .van-nav-bar .van-icon{
    color: #000;
  }
  .van-nav-bar__right,
  .van-nav-bar__left {
    .van-icon {
      // color: #fff;
      font-weight: 600;
          font-size: 20px
    }
  }
  .van-nav-bar__title{
    // color: #fff;
    
font-size: 17px;
  }
.footerBox{
      white-space: nowrap;
}
  //无列表数据状态
  .noDatabody {
    // height: 100vh;
    height: 110vw;
    
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
   .noDataImg {
      width: 152px;
      margin-top: -20vh;
    }
    .txt {
      padding: 17px 0;
      font-size: 14px;
color: #A2A2A2;
    }
  }
   //无列表数据状态
   .noDatabody {
    height: 93vh;
  
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .noDataImg {
      width: 152px;
      margin-top: -20vh;
    }
  }
  .van-nav-bar__right {
    .van-nav-bar__text {
      color: #444;
    }
  }
  
</style>




// WEBPACK FOOTER //
// src/App.vue